@reference "../../styles/ui.css";

.pagination-wrapper {
  @apply basis-0 flex flex-col md:flex-row items-stretch justify-center shrink-0;

  .disabled {
    @apply opacity-50 pointer-events-none;
  }

  .size-and-total {
    @apply flex grow items-center justify-between ml-0 md:ml-3 mt-3 md:mt-0 w-full;
  }
}

.pagination-wrapper.bottom {
  @apply mb-0 mt-3;
}

.pagination-wrapper.top {
  @apply mb-3 mt-0;
}
